import request from 'utils/request';

const api = {
  OVERALL_LIST: '/api/prod/list',
};

export function getProdList(query) {
  return request({
    url: api.OVERALL_LIST,
    method: 'get',
    params: query,
  });
}
